import FormField from '@cloudscape-design/components/form-field'
import Select from '@cloudscape-design/components/select'

const DME_TYPES = [
  { label: 'Respiratory / CPAP / Oxygen', value: 'respiratory' },
  { label: 'Mobility / Wheelchairs', value: 'mobility' },
  { label: 'Wound Care / Diabetic Supplies', value: 'wound_care' },
  { label: 'General DME Supplier', value: 'general' },
]

interface Props {
  value: string
  onChange: (v: string) => void
}

export function StepBusinessType({ value, onChange }: Props) {
  const selected = DME_TYPES.find(o => o.value === value) ?? null
  return (
    <FormField label="What type of DME does your business specialize in?" stretch>
      <Select
        selectedOption={selected}
        onChange={e => onChange(e.detail.selectedOption.value ?? '')}
        options={DME_TYPES}
        placeholder="Select a specialty"
      />
    </FormField>
  )
}
